import React from "react";
import { motion } from "framer-motion";

export default function Hero() {
  return (
    // <header
    //   id="hero"
    //   className="d-flex align-items-center justify-content-center position-relative text-center text-white"
    //   style={{
    //     height: "100vh",
    //     overflow: "hidden",
    //     backgroundImage:
    //       "url('https://images.pexels.com/photos/3184306/pexels-photo-3184306.jpeg')",
    //     backgroundSize: "cover",
    //     backgroundPosition: "center",
    //   }}
    // >
    <header
  id="hero"
  className="d-flex align-items-center justify-content-center position-relative text-center text-white"
  style={{
    height: "100vh",
    overflow: "hidden",
  }}
>
  {/* Background Video */}
  <video
    autoPlay
    loop
    muted
    playsInline
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      zIndex: -1,
    }}
  >
    <source src="/dashboardvideo.mp4" type="video/mp4" />
  </video>

  {/* Your Content on top */}
  {/* <div style={{ zIndex: 1 }}>
    <h1>Your Heading</h1>
    <p>Your subtitle text here</p>
  </div> */}
      {/* ✅ Dark Overlay */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background:
            "linear-gradient(to bottom right, rgba(54, 54, 54, 0.82), rgba(139, 137, 137, 0.06))",
          zIndex: 1,
        }}
      ></div>

      {/* ✅ Content */}
      <motion.div
        className="container position-relative"
        style={{ zIndex: 2, maxWidth: "800px" }}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <motion.h1
          className="display-4 fw-bold mb-3"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          Smart Influence. Smarter Decisions.
        </motion.h1>

        <motion.p
          className="lead text-light mx-auto mb-4"
          style={{ maxWidth: "700px" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 1 }}
        >
          We blend impactful influencer marketing with deep financial research
          to help brands grow with confidence.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
        >
          {/* ✅ Primary Gradient Button */}
          <motion.a
            href="#contact"
            className="btn btn-lg px-5 py-3 fw-semibold me-3"
            style={{
              background:
                "linear-gradient(90deg, rgba(255,0,110,1) 0%, rgba(255,140,0,1) 100%)",
              border: "none",
              color: "#fff",
              borderRadius: "50px",
              boxShadow: "0 6px 18px rgba(255,0,110,0.25)",
            }}
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.97 }}
          >
            Partner With Us
          </motion.a>

          {/* ✅ Secondary Gradient Hover Button */}
          <motion.a
            href="#about"
            className="btn btn-lg px-5 py-3 fw-semibold"
            style={{
              background: "transparent",
              borderRadius: "50px",
              border: "2px solid rgba(255,140,0,1)",
              color: "#fff",
            }}
            whileHover={{
              scale: 1.08,
              background:
                "linear-gradient(90deg, rgba(255,0,110,1) 0%, rgba(255,140,0,1) 100%)",
              border: "none",
            }}
            whileTap={{ scale: 0.97 }}
          >
            Discover Our Expertise
          </motion.a>
        </motion.div>
      </motion.div>
    </header>
  );
}
